/**
 * notificationAPI — les notifications in-app de l'utilisateur connecté (2026-09-14).
 *
 * Première consommation côté écran : la « carte d'embarquement » du conducteur
 * (`type = 'pool_boarding_pass'`, créée par le guichet à la réservation). Le
 * serveur filtre sur l'utilisateur du jeton : aucun `user_id` ne part d'ici.
 *
 * Forme de `list` : `{ data: [...], count }` (pas d'enveloppe `ok`).
 */
import { apiRequest } from './core.js';

export const notificationAPI = {
  list: ({ unreadOnly = false, limit = 20 } = {}) =>
    apiRequest(`/notifications?unread_only=${unreadOnly ? 'true' : 'false'}&limit=${limit}`),
  markRead: (id) => apiRequest(`/notifications/${encodeURIComponent(id)}/read`, { method: 'POST' }),
  dismiss: (id) => apiRequest(`/notifications/${encodeURIComponent(id)}/dismiss`, { method: 'POST' }),
};

export default notificationAPI;
